import { PhotoSrcProps } from 'components/Photo/Photo'
import { Colour } from 'components/variables'
import React from 'react'
import { ConnectedComponent } from 'react-redux'
import { match } from 'react-router'
import { AllowedFunnelOrderValues, FunnelOrder } from '../models/funnelOrder'
import { Theme } from '../models/funnelOrder/theme'

export enum EntryType {
  Preset,
  Flavour,
  Modal,
  Funnel,
}

interface StyleProps {
  navbarColor?: 'black' | 'white'
  headingColor?: 'black' | 'white'
  peopleNegative?: boolean
}

export interface ContentProps {
  topList?: number
  explainLeft?: number
  explainRight?: number
}

export enum EntryKey {
  none = '',
  goedkoopste = 'beste-prijs',
  popular = 'favoriet',
  solotogether = 'solo-together',
  multicity = 'multi-city',
  drivePopular = 'autoreis-favoriet',
  driveCheapest = 'autoreis-beste-prijs',
  ultimate = 'roadtrip-xl',
  multidrive = 'multi-roadtrip',
  incontrol = 'in-control',
  bucketList = 'bucket-list',
  escapeTour = 'escape-tour',
  broke = 'broke',
  train = 'train',
  voorjaar = 'citytrip-voorjaar',
  newCities = 'new-places',
  summerHoliday = 'summer-holiday',
  lastMinute = 'last-minute',
  foodLoversDrive = 'food-lovers-drive',
  foodLoversFly = 'food-lovers-fly',
  themeOfTheMonth = 'theme-of-the-month',
}

export enum EntryCategory {
  originals,
  presets,
  food,
  activity,
  sport,
}

export interface EntryProps {
  entry: Entry
  match: match<any>
}

export interface EntryModalProps {
  entry: Entry
  onClose(): void
}

export interface EntryCard {
  contentKey: string
  photoWebp: string
  photo: string
  icon?: JSX.Element
  showNew?: boolean
  showTemp?: boolean
  colour?: Colour
}

export interface EntryPage {
  name: string
  url: { [key: string]: string }
  photos: PhotoSrcProps
  params: Partial<FunnelOrder>
  allowedParams?: Partial<AllowedFunnelOrderValues>
  cheapest?: boolean
  style?: StyleProps
  content?: ContentProps
  overridePage?: React.ComponentClass<EntryProps> | React.FC<EntryProps>
}

export interface Entry {
  name: string
  key: EntryKey
  type: EntryType
  active: boolean
  hide?: boolean
  order?: { [key: string]: number }
  colour: Colour
  startFrom?: Date | string
  expiry?: Date | string
  countDownNumber?: number
  countDownStartNumber?: number
  theme?: Theme
  category: EntryCategory[]
  card: EntryCard
  page?: EntryPage
  modal?: React.ComponentClass<EntryModalProps> | ConnectedComponent<any, any>
}
